import axios from "axios";
import { DCAuthToken } from "./Settings";
const token = DCAuthToken();
const XData = axios.create({
  baseURL: process.env.REACT_APP_USER_API_BASE_URL + "type_equipement", 
  headers : { Authorization : 'Bearer ' + token }
});

export async function GetTypesEquipements(SetDatas)
{
  const result = await XData.get('/');
  SetDatas(result.data);
}


export async function GetTypeEquipement(id, SetDatas)
{
    const result = await XData.get('/'+id);
    SetDatas(result.data);
  
}
